// Formatting helpers shared across the quiz UI.

const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

/** Convert ASCII digits in a value to Persian digits. */
export const toFa = (value: string | number): string =>
  String(value).replace(/\d/g, (d) => FA_DIGITS[Number(d)]);

/** mm:ss countdown with Persian digits. */
export const formatClock = (totalSeconds: number): string => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return toFa(`${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`);
};

/** Jalali date + time, e.g. «۱۴۰۴/۴/۳  ۲۰:۳۹». Empty string for missing input. */
export const formatJalaliDateTime = (iso?: string | null): string => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const date = d.toLocaleDateString("fa-IR");
  const time = d.toLocaleTimeString("fa-IR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${date}  ${time}`;
};

/** Human duration between two timestamps, e.g. «۱۵ دقیقه و ۱۶ ثانیه». */
export const formatDuration = (
  startIso?: string | null,
  endIso?: string | null,
): string => {
  if (!startIso || !endIso) return "";
  const start = new Date(startIso).getTime();
  const end = new Date(endIso).getTime();
  if (Number.isNaN(start) || Number.isNaN(end) || end < start) return "";
  const totalSeconds = Math.round((end - start) / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes && seconds) return `${toFa(minutes)} دقیقه و ${toFa(seconds)} ثانیه`;
  if (minutes) return `${toFa(minutes)} دقیقه`;
  return `${toFa(seconds)} ثانیه`;
};

/** «۱۵ دقیقه» style label for a minutes value (used on the intro card). */
export const formatMinutes = (minutes?: number | null): string =>
  typeof minutes === "number" ? `${toFa(minutes)} دقیقه` : "—";
